export enum HomeTabType {
	HOME_VIEW = 'HOME_VIEW',
	DASHBOARD = 'DASHBOARD',
}

export interface HomeTab {
	type: HomeTabType;
	id: string;
	name: string;
}
